'use strict'
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

export default function StalenessModal ({ open, onClose, freshness, onSyncNow, onProceedStale }) {
  if (!freshness) return null

  const routingAge = freshness.routingSyncAgeHours == null
    ? 'missing'
    : `${freshness.routingSyncAgeHours}h ago`
  const workTicketAge = freshness.workTicketSyncAgeHours == null
    ? 'missing'
    : `${freshness.workTicketSyncAgeHours}h ago`
  const reasons = Array.isArray(freshness.staleReasons) && freshness.staleReasons.length
    ? freshness.staleReasons
    : ['unknown']

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Stale Data Detected</DialogTitle>
      <DialogContent>
        <Alert severity="warning" style={{ marginBottom: 16 }}>
          The underlying Aspire data is stale. Creating a scenario from outdated data may produce inaccurate results.
        </Alert>
        <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <Typography variant="body2" style={{ minWidth: 140 }}>Routing sync:</Typography>
            <Chip size="small" label={routingAge} />
          </Box>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <Typography variant="body2" style={{ minWidth: 140 }}>Work ticket sync:</Typography>
            <Chip size="small" label={workTicketAge} />
          </Box>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            <Typography variant="body2" style={{ minWidth: 140 }}>Threshold:</Typography>
            <Chip size="small" label={`${freshness.freshnessThresholdHours || 6}h`} />
          </Box>
          <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
            <Typography variant="body2" style={{ minWidth: 140 }}>Reasons:</Typography>
            {reasons.map((r, i) => <Chip key={i} size="small" color="secondary" label={r} />)}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="outlined" color="primary" onClick={onSyncNow}>
          Sync Now
        </Button>
        <Button variant="contained" color="secondary" onClick={onProceedStale}>
          Proceed with Stale Data
        </Button>
      </DialogActions>
    </Dialog>
  )
}
